import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import {
  UpdateCompanySpecifiedRequest,
  UpdateCompanySpecifiedResponse,
} from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function updateCompanySpecified(
  request: UpdateCompanySpecifiedRequest
): Promise<UpdateCompanySpecifiedResponse> {
  const res = await axiosInstance.post<UpdateCompanySpecifiedResponse>(
    api.updateCompanySpecified,
    request
  );
  return res.data;
}

const useUpdateCompanySpecifiedMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: UpdateCompanySpecifiedResponse) => void;
  onError?: (error: Error) => void;
} = {}) => {
  const mutation = useMutation({
    mutationKey: queryKeys.favorite.updateCompanySpecified(),
    mutationFn: updateCompanySpecified,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useUpdateCompanySpecifiedMutation;
